"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UsernameAttributes;
(function (UsernameAttributes) {
    UsernameAttributes["EMAIL"] = "email";
    UsernameAttributes["PHONE_NUMBER"] = "phone_number";
    UsernameAttributes["USERNAME"] = "username";
})(UsernameAttributes = exports.UsernameAttributes || (exports.UsernameAttributes = {}));
//# sourceMappingURL=types.js.map